import { render, staticRenderFns } from "./renovar-licenca.vue?vue&type=template&id=f10ad91c&"
import script from "./renovar-licenca.vue?vue&type=script&lang=js&"
export * from "./renovar-licenca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports